import React from "react";
import Styles from "./Footer.module.css";
import FooterLinks from "./FooterLinks";
import Button from "../UI/Button";

export default function Footer() {
  return (
    <>
      <div className="text-[#80FF00] text-sm text-center lg:hidden py-5 ">
        Privacy & Terms | Cookie Policy
      </div>
      <div className="w-full hidden flex-col items-end pr-16 xl:pr-24 pt-0 xl:pt-[60px] pb-12 lg:flex">
        <div className="flex items-center">
          <span className="mr-8 xl:mr-11 font-Helvetica text-white">
            2022. PurgeTown.com All Rights Reserved
          </span>

          <Button
            text={"Play Now"}
            height={"48px"}
            width={"184px"}
            radius={"21px"}
            isGreen={true}
          />

          <div
            className={`${Styles.button} ml-10 xl:ml-16 bg-[#7E7E7E] border flex h-12 w-72 text-center items-center border-[#EEEEEE]`}
            style={{ WebkitTextStrokeColor: "#ACACAC" }}
          >
            <div className="flex mx-auto items-center cursor-pointer">
              <img src="/images/footer/play.svg" alt="play" className="mr-2" />
              <span className=" font-Red-Undead text-xl text-[#3E3E3E]">
                WATCH TRAILER
              </span>
            </div>
          </div>
        </div>

        <FooterLinks />
      </div>
    </>
  );
}
